<template>
  <div v-if="!isLoading && benchmark">
    <div
      class="px-10 py-2 d-flex flex-column justify-center align-center text-center"
    >
      <v-img
        max-width="300"
        width="auto"
        :src="require('@/assets/logos/braingihappy.png')"
      ></v-img>
    </div>

    <div class="d-flex justify-center align-center">
      <div
        style="max-width: 1100px; margin: 10vh 0"
        class="imagebox"
        :style="{
          'grid-template-columns': $vuetify.display.mobile ? '1fr' : '1fr 1fr',
          margin: $vuetify.display.mobile ? '5vh 10vw' : '10vh 0',
        }"
      >
        <div>
          <h2 class="mt-10 mb-6">Neuro UX Benchmark</h2>
          <p class="largetext">
            Doe mee met onze Neuro UX Benchmark
            {{ benchmark?.title }}. Krijg inzicht in de emotionele klantervaring
            gemeten met EEG en afgezet tegen concurrenten.
          </p>
        </div>
        <v-img
          height="400"
          width="100%"
          :src="require('@/assets/neuro-ux.avif')"
        ></v-img>
      </div>
    </div>
    <div>
      <div class="wave-section d-flex justify-center align-center flex-column">
        <!-- <svg
          class="wave-bottom"
          viewBox="0 0 1440 60"
          preserveAspectRatio="none"
          style="display: block; width: 100%; height: 60px"
        >
          <path
            d="M0,30 C360,60 1080,0 1440,30 L1440,60 L0,60 Z"
            :fill="color"
          />
        </svg> -->
        <div
          style="
            width: 100%;

            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            padding: 8vh 0;
          "
          :style="{ backgroundColor: color }"
        >
          <div
            style="
              display: flex;
              justify-content: center;
              align-items: flex-end;
              width: 100%;
            "
          >
            <div
              v-for="(item, idx) in fiveCompanies"
              :key="idx"
              class="benchmark-phone"
              :class="`benchmark-phone-${idx}`"
            >
              <img
                src="@/assets/iphone.png"
                alt="iphone"
                class="benchmark-iphone-img"
              />
              <div style="padding-top: 12%" class="bg-white benchmark-ah-img">
                <img :src="item.image" alt="ah" />
              </div>
            </div>
          </div>
        </div>

        <!-- <svg
          class="wave-top"
          viewBox="0 0 1440 60"
          preserveAspectRatio="none"
          style="display: block; width: 100%; height: 60px"
        >
          <path d="M0,30 C360,60 1080,0 1440,30 L1440,0 L0,0 Z" :fill="color" />
        </svg> -->
      </div>
    </div>

    <div
      class="d-flex flex-column justify-center align-center"
      style="min-height: 250px; padding: 10vh 0"
    >
      <div
        class="textbox"
        :style="{
          'flex-direction': $vuetify.display.mobile ? 'column' : 'row',
          padding: $vuetify.display.mobile ? '3vh 10vw' : '10vh 0',
        }"
      >
        <div>
          <h2>Neuro UX Benchmark</h2>
          <p style="font-size: 23px">
            <b>{{ benchmark?.title }}</b>
          </p>
          <v-btn
            class="mt-10 px-8"
            variant="flat"
            height="60"
            tile
            size="large"
            color="blueButton"
            style="text-transform: none; font-weight: 700; padding: 0 20px"
            @click="openCalendar"
          >
            Plan een afspraak
          </v-btn>
        </div>
        <div class="largetext">
          <p style="margin-bottom: 10px">
            Wie biedt de beste online ervaring voor
            <b style="font-weight: 700">{{ benchmark?.title }}?</b>
          </p>
          <p>
            Ontdek het met onze Neuro UX Benchmark. Welk merk scoort het best
            bij klanten? Niet op basis van wat ze zeggen, maar op basis van wat
            ze écht ervaren. Met EEG-onderzoek brengen we het onbewuste brein in
            kaart en vergelijken we jouw website of app met de
            grootste/bekendste Nederlandse concurrenten.
          </p>
          <div style="margin-bottom: 40px; margin-top: 20px">
            <b style="font-weight: 700">Wat kan je verwachten?</b>
            <ul
              style="margin: 10px 0 0 0; padding-left: 22px; font-size: inherit"
            >
              <li>Inzicht in de emotionele klantervaring gemeten met EEG.</li>
              <li>Analyses van key bottlenecks in de customer journey.</li>
              <li>
                Vergelijking met concurrenten op basis van objectieve data.
              </li>
            </ul>
          </div>
          <p style="margin-bottom: 10px">
            <b>Inschrijvingen open tot 30 oktober</b><br />
            <span style="font-size: 18pt; font-weight: bold"
              >Prijs: € 11.500</span
            >
          </p>
        </div>
      </div>
    </div>

    <div>
      <div class="d-flex justify-center align-center">
        <video
          src="https://s3.amazonaws.com/webflow-prod-assets/6656fdf094d7d58d3829c544/6656fdf094d7d58d3829c5d9_Timeline%201.mp4"
          autoplay
          loop
          muted
          style="width: 100%; height: 100%; object-fit: cover; display: block"
        ></video>
      </div>

      <div
        class="d-flex justify-center align-center"
        style="min-height: 250px; padding: 10vh 0"
      >
        <div
          style="max-width: 1100px"
          :style="{ padding: $vuetify.display.mobile ? '3vh 10vw' : '10vh 0' }"
        >
          <div class="textbox">
            <h2 class="mb-10">Hoe werkt het?</h2>
          </div>
          <div
            class="mt-4"
            style="
              display: grid;

              grid-template-rows: 1fr 1fr;
            "
            :style="{
              'grid-template-columns': $vuetify.display.mobile
                ? '1fr'
                : '1fr 1fr 1fr',
              gap: $vuetify.display.mobile ? '20px' : '50px',
            }"
          >
            <div>
              <h3>Inzicht in het onbewuste brein</h3>
              <p class="mediumtext" style="margin-bottom: 15px">
                EEG en eyetracking onthullen wat mensen voelen, waar ze kijken
                en waar het wringt – helemaal objectief.
              </p>
            </div>

            <div>
              <h3>Een objectieve vergelijking</h3>
              <p class="mediumtext" style="margin-bottom: 15px">
                We laten zien wie de beste ervaring biedt op de belangrijkste
                momenten in een online journey. Zie hoe jouw website of app
                scoort ten opzichte van andere spelers in de markt.
              </p>
            </div>

            <div>
              <h3>Concrete inzichten per stap in de journey</h3>
              <p class="mediumtext" style="margin-bottom: 15px">
                Welke pagina’s maken indruk? Waar haken mensen af? Op welke
                momenten piekt hun emotie - positief of negatief? Je krijgt een
                glashelder beeld van bottlenecks en kansen.
              </p>
            </div>

            <div>
              <h3>Resultaten die je niet uit een interview haalt</h3>
              <p class="mediumtext" style="margin-bottom: 15px">
                We kijken letterlijk in het hoofd van je doelgroep. Geen sociaal
                wenselijke antwoorden, maar echte emotionele reacties.
              </p>
            </div>

            <div>
              <h3>Direct toepasbare aanbevelingen</h3>
              <p class="mediumtext" style="margin-bottom: 15px">
                Je krijgt praktische inzichten en adviezen om de online ervaring
                momenten in een online journey. Zie hoe jouw website of app
                scoort ten opzichte van andere spelers in de markt.
              </p>
            </div>

            <div>
              <h3>Lees meer achtergrond informatie</h3>
              <p class="mediumtext" style="margin-bottom: 15px">
                Bekijk de pdf met meer achtergrond informatie over de Neuro UX
                Benchmark.
              </p>
              <v-btn
                variant="flat"
                height="50"
                tile
                size="large"
                color="blueButton"
                style="text-transform: none; font-weight: 700; padding: 0 20px"
                @click="openBackgroundInfo"
              >
                Download pdf
              </v-btn>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="bg-primary d-flex justify-center align-center"
      style="margin-bottom: 100px; padding: 100px 0"
    >
      <div
        style="max-width: 1100px; width: 100%"
        :style="{ padding: $vuetify.display.mobile ? '3vh 10vw' : '10vh 0' }"
      >
        <h2 style="margin-bottom: 50px">Wat ontvang je?</h2>
        <v-row>
          <v-col cols="12" md="6">
            <h3 style="margin-bottom: 30px">
              Persoonlijk optimalisatie rapport
            </h3>

            <div class="d-flex align-start mb-3" style="gap: 10px">
              <v-icon color="success">mdi-check</v-icon>
              <div class="mediumtext">
                Volledig Braingineers <b>neuromarketing onderzoek</b>.
              </div>
            </div>

            <div class="d-flex align-start mb-3" style="gap: 10px">
              <v-icon color="success">mdi-check</v-icon>
              <div class="mediumtext">
                Minimaal <b>5 key insights</b> met psychologische verklaring van
                het online klantgedrag.
              </div>
            </div>

            <div class="d-flex align-start mb-3" style="gap: 10px">
              <v-icon color="success">mdi-check</v-icon>
              <div class="mediumtext">
                Drie maanden toegang tot <b>Brainpeek</b>: Incl. participant
                feedback, schermopnames, eye‑tracking en EEG data.
              </div>
            </div>

            <div class="d-flex align-start mb-3" style="gap: 10px">
              <v-icon color="success">mdi-check</v-icon>
              <div class="mediumtext">
                <b>Insights rapport</b> met alle learnings en suggesties uit
                Brainpeek.
              </div>
            </div>

            <div class="d-flex align-start mb-3" style="gap: 10px">
              <v-icon color="success">mdi-check</v-icon>
              <div class="mediumtext">
                <b>Live resultaten sessie</b> met een UX Research Consultant en
                Q&A.
              </div>
            </div>

            <div class="d-flex align-start" style="gap: 10px">
              <v-icon color="success">mdi-check</v-icon>
              <div class="mediumtext">
                <b>Sparringssessie</b> voor optimalisaties en aanvullende
                onderzoeksvragen.
              </div>
            </div>
          </v-col>

          <v-col cols="12" md="6">
            <h3 style="margin-bottom: 30px">Benchmark rapport</h3>

            <div class="d-flex align-start mb-3" style="gap: 10px">
              <v-icon color="success">mdi-check</v-icon>
              <div class="mediumtext">
                <b>CX/UX vergelijking</b> inclusief ranking: zowel op de gehele
                journey als op pagina‑niveau.
              </div>
            </div>

            <div class="d-flex align-start mb-3" style="gap: 10px">
              <v-icon color="success">mdi-check</v-icon>
              <div class="mediumtext">
                <b>Best practices</b> a.d.h.v. do’s en don’ts.
              </div>
            </div>

            <div class="d-flex align-start" style="gap: 10px">
              <v-icon color="success">mdi-check</v-icon>
              <div class="mediumtext">
                Belangrijkste <b>bottlenecks</b> & ‘<b>conversion killers</b>’.
              </div>
            </div>
          </v-col>
        </v-row>
      </div>
    </div>

    <div
      style="margin: 10vh 2vw"
      :style="{ padding: $vuetify.display.mobile ? '3vh 10vw' : '10vh 0' }"
    >
      <div
        class="d-flex justify-center align-center flex-wrap"
        style="gap: 80px"
      >
        <v-img
          :src="require('@/assets/people.png')"
          height="100%"
          style="padding: 0 7vw"
        ></v-img>
        <div style="max-width: 600px">
          <h2 class="mb-4" style="font-weight: 700">Laten we verder praten!</h2>
          <p class="largetext">
            Wil je meer weten over onze Neuro UX Benchmark? Of wil je graag een
            plek reserveren? Plan een afspraak met ons in!
          </p>
          <v-btn
            class="mt-10"
            variant="flat"
            height="50"
            tile
            size="large"
            color="blueButton"
            style="text-transform: none; font-weight: 700; padding: 0 20px"
            @click="openCalendar"
          >
            Plan een afspraak
          </v-btn>
        </div>
      </div>
    </div>

    <v-divider></v-divider>
    <div class="py-4 d-flex justify-center align-center">
      <v-img
        max-width="300"
        width="auto"
        :src="require('@/assets/logos/braingihappy.png')"
      ></v-img>
    </div>
  </div>
  <div class="d-flex justify-center align-center" style="height: 100vh" v-else>
    <div class="d-flex justify-center flex-column align-center">
      <v-img
        max-width="300"
        class="mb-4"
        width="auto"
        :src="require('@/assets/logos/braingihappy.png')"
      ></v-img>
      <div style="width: 100px">
        <v-progress-linear indeterminate color="primary" size="25" width="100">
        </v-progress-linear>
      </div>
    </div>
  </div>
</template>

<script>
import { doc, getDoc, query, collection, getDocs } from "firebase/firestore";
import { db } from "@/firebase";

export default {
  data() {
    return {
      benchmark: null,
      color: "rgba(241, 218, 65, 1)",
      isLoading: true,
    };
  },
  computed: {
    fiveCompanies() {
      let r = this.benchmark?.companies;
      if (this.$route.query.id) {
        // Move the object with index (params.id) to index position 2
        const idx = this.$route.query.id;
        if (idx > -1 && idx !== 2) {
          const [item] = r.splice(idx, 1);
          r.splice(2, 0, item);
        }
      }
      console.log("r", r);
      if (r.length > 5) {
        console.log("r.length < 5", r.length);
        r = r.slice(0, 5);
      }
      console.log("r", r);
      return r;
    },
  },
  async mounted() {
    console.log(this.$route.query.id);
    console.log(this.benchmarkItems);
    if (this.$route.params.id) {
      let id = this.$route.params.id;
      console.log(id);
      // Capitalize first letter of id
      if (id && typeof id === "string" && id.length > 0) {
        id = id.charAt(0).toUpperCase() + id.slice(1);
      }

      console.log("fetching benchmark", id);

      const docRef = doc(
        db,
        "sales",
        "benchmarks",
        "neuro-ux",
        encodeURIComponent(id)
      );
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        this.benchmark = docSnap.data();
        console.log("found benchmark: ", this.benchmark);
        this.benchmark.uid = docSnap.id;
        this.benchmark.companies = [];
        const companiesReq = query(
          collection(
            db,
            "sales",
            "benchmarks",
            "neuro-ux",
            docSnap.id,
            "companies"
          )
        );
        const companiesSnap = await getDocs(companiesReq);
        companiesSnap.docs.map((c) => this.benchmark.companies.push(c.data()));

        if (
          this.$route.query.id &&
          this.benchmark.companies[this.$route.query.id].color
        ) {
          this.color = this.benchmark.companies[this.$route.query.id].color;
        }
        console.log("found benchmark: ", this.benchmark);
        this.isLoading = false;
      } else {
        this.benchmark = { companies: [] };
        this.isLoading = false;
      }
    }

    console.log(
      "InboundBenchmark component mounted - starting LinkedIn pixel setup"
    );

    // LinkedIn Pixel Tracking
    const _linkedin_partner_id = "7700914";
    console.log("LinkedIn Partner ID:", _linkedin_partner_id);

    window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
    window._linkedin_data_partner_ids.push(_linkedin_partner_id);
    console.log(
      "LinkedIn data partner IDs:",
      window._linkedin_data_partner_ids
    );

    (function (l) {
      console.log("LinkedIn pixel function called, lintrk exists:", !!l);
      if (!l) {
        window.lintrk = function (a, b) {
          console.log("LinkedIn lintrk called with:", a, b);
          window.lintrk.q.push([a, b]);
        };
      }
      window.lintrk.q = [];
      var s = document.getElementsByTagName("script")[0];
      var b = document.createElement("script");
      b.type = "text/javascript";
      b.async = true;
      b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
      console.log("Loading LinkedIn script from:", b.src);
      s.parentNode.insertBefore(b, s);

      // Test the pixel after loading
      setTimeout(() => {
        console.log("Testing LinkedIn pixel...");
        if (window.lintrk) {
          window.lintrk("track", { conversion_id: 123456 });
          console.log("LinkedIn pixel test fired");

          // Check if the pixel request was actually sent
          setTimeout(() => {
            console.log("LinkedIn pixel queue:", window.lintrk.q);
            console.log(
              "LinkedIn data partner IDs:",
              window._linkedin_data_partner_ids
            );
          }, 1000);
        } else {
          console.log("LinkedIn lintrk not available");
        }
      }, 2000);
    })(window.lintrk);

    // Add noscript fallback
    const noscript = document.createElement("noscript");
    const img = document.createElement("img");
    img.height = 1;
    img.width = 1;
    img.style.display = "none";
    img.alt = "";
    img.src = "https://px.ads.linkedin.com/collect/?pid=7700914&fmt=gif";
    noscript.appendChild(img);
    document.head.appendChild(noscript);
    console.log("LinkedIn noscript fallback added");
  },
  methods: {
    openBackgroundInfo() {
      // Direct link to the PDF hosted on Firebase Storage
      const pdfUrl =
        "https://firebasestorage.googleapis.com/v0/b/valsplat-b07bc.firebasestorage.app/o/downloads%2FAchtergrond%20Informatie%20-%20Neuro%20UX%20Benchmark.pdf?alt=media&token=c5265fd6-f4bb-4ae5-a7b3-edbbd9d7b3a1";
      // Open the PDF in a new tab
      window.open(pdfUrl, "_blank");
    },

    openCalendar() {
      try {
        if (typeof window.lintrk === "function") {
          // TODO: replace 123456 with a real LinkedIn conversion ID
          window.lintrk("track", { conversion_id: 123456 });
          console.log("LinkedIn CTA conversion fired");
        } else {
          console.log("LinkedIn lintrk not available at click time");
        }
      } catch (e) {
        console.log("LinkedIn tracking error:", e);
      }

      window.open(
        "https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ1-4Iybd_JPfQyKIkZVFLyRPPoT5tCdF1GnliNos382rhDtYUf7doZ-3aZlMH8FOsH-HWySBlQX",
        "_blank"
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.largetext {
  font-size: 24px;
}
.mediumtext {
  font-size: 18px;
}
.textbox {
  display: flex;
  gap: 100px;
  max-width: 1100px;
}
.imagebox {
  display: grid;
  grid-template-columns: 1fr 1fr;
  max-width: 1100px;
}
h2 {
  font-size: 56px;
  font-weight: 700;
  line-height: 1;
  margin-bottom: 10px;
}
h3 {
  font-size: 32px;
  font-weight: 700;
  line-height: 1;
  margin-bottom: 25px;
}

@media (max-width: 768px) {
  h2 {
    font-size: 40px;
  }
  h3 {
    margin-bottom: 10px;
    font-size: 24px;
  }
  .largetext {
    font-size: 20px;
  }
  .mediumtext {
    font-size: 16px;
  }
}
.responsive-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  min-height: 450px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    &.reverse {
      display: flex;
      flex-direction: column-reverse;
      grid-template-columns: unset;
    }
  }
}

@import url("https://fonts.googleapis.com/css2?family=Outfit:wght@100..900&display=swap");

h1 {
  font-size: 52px;
  font-weight: 600;
}

* {
  font-family: "Outfit", sans-serif;
  font-optical-sizing: auto;
  font-weight: 400;
  font-style: normal;
}

.benchmark-phone {
  position: relative;
  width: 18vw;
  max-width: 220px;
  min-width: 120px;
  transition: transform 0.3s, filter 0.3s;
  display: block;
  /* ensure child z-indexes don't bleed across siblings */
  isolation: isolate;
}
.benchmark-phone-0 {
  z-index: 1;
  transform: scale(0.85) translateY(20px) translateX(150px);
}
.benchmark-phone-1 {
  z-index: 2;
  transform: scale(0.92) translateY(10px) translateX(50px);
}
.benchmark-phone-2 {
  z-index: 3;
  transform: scale(1) translateY(0);
}
.benchmark-phone-3 {
  z-index: 2;
  transform: scale(0.92) translateY(10px) translateX(-50px);
}
.benchmark-phone-4 {
  z-index: 1;
  transform: scale(0.85) translateY(20px) translateX(-150px);
}
.benchmark-iphone-img {
  width: 100%;
  height: auto;
  max-height: 40vh;
  z-index: 3;
  position: relative;
  display: block;
}
.benchmark-ah-img {
  position: absolute;
  /* use insets instead of fixed height so it scales with the phone */
  top: 3%;
  left: 5%;
  right: 5%;
  bottom: 3%;
  overflow: hidden;
  border-radius: 5%;
  z-index: 2;
  display: block;
}

.benchmark-ah-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top;
  display: block;
}
</style>
